import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';

class Loading extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.props.isOpen} className={this.props.className}>
          <ModalBody>
              <Spinner color="primary" style={{width:'4rem', height:'4rem', margin:'auto auto auto auto', display:'block'}}/>
              <h1 className="text-center">אנא המתן...</h1>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Loading;